export type SearchResultType =
    | 'agent'
    | 'data_source'
    | 'table'
    | 'hyperform'
    | 'dashboard'
    | 'report'
    | 'tracker'
    | 'task';

export interface SearchBreadcrumb {
    label: string;
    id?: string | number;
    type?: string;
}

export interface SearchResult {
    type: SearchResultType;
    id: string | number;
    name: string;
    description?: string;
    breadcrumb: SearchBreadcrumb[];
}

export interface SearchResponse {
    query: string;
    count: number;
    results: SearchResult[];
}

/** One UI group of results sharing the same `type`, for the autocomplete panel. */
export interface SearchResultGroup {
    type: SearchResultType;
    labelKey: string;
    icon: string;
    results: SearchResult[];
}

/** Group labels reuse existing i18n keys already used for these features' nav/page titles. */
export const SEARCH_RESULT_TYPE_LABEL_KEYS: Record<SearchResultType, string> = {
    agent: 'SAI Agents',
    data_source: 'Data Sources',
    table: 'Tables',
    hyperform: 'Hyper Forms',
    dashboard: 'Dashboards',
    report: 'Reports',
    tracker: 'Tracker',
    task: 'Tasks',
};

/**
 * Group icons mirror each feature's sidebar icon (`mock-api/common/navigation/data.ts`), so a
 * result group is marked with the same glyph as the destination it routes to. `table` has no nav
 * item of its own and takes the generic grid.
 */
export const SEARCH_RESULT_TYPE_ICONS: Record<SearchResultType, string> = {
    agent: 'heroicons_outline:cpu-chip',
    data_source: 'heroicons_outline:square-3-stack-3d',
    table: 'heroicons_outline:table-cells',
    hyperform: 'heroicons_outline:rectangle-group',
    dashboard: 'heroicons_outline:squares-2x2',
    report: 'heroicons_outline:paper-airplane',
    tracker: 'heroicons_outline:presentation-chart-bar',
    task: 'heroicons_outline:check-circle',
};
